import {TCurrency} from '@edna/utils';

export enum EPaymentCorrectionType {
  STORNO = 'STORNO',
  CANCEL_STORNO = 'CANCEL_STORNO',
  UPDATE_SUM = 'UPDATE_SUM',
  CARD_PAYMENTS = 'CARD_PAYMENTS',
}

export type TPaymentCorrectionType = keyof typeof EPaymentCorrectionType;

export const STORNO_CORRECTION_TYPES = [
  EPaymentCorrectionType.STORNO,
  EPaymentCorrectionType.CANCEL_STORNO,
  EPaymentCorrectionType.UPDATE_SUM,
];

export const CARD_PAYMENTS_CORRECTION_TYPES = [EPaymentCorrectionType.CARD_PAYMENTS];

export enum EBilledEventState {
  STORNED = 'STORNED',
  STORNO = 'STORNO',
  CLOSE_DEBT = 'CLOSE_DEBT',
}

type TBilledEventState = keyof typeof EBilledEventState;

export enum EBilledEventConfirmation {
  CLOSED = 'CLOSED',
  HOLD = 'HOLD',
  REFUNDED = 'REFUNDED',
  POSTPONED = 'POSTPONED',
  STORNO = 'STORNO',
}

export type TBilledEvent = {
  id: number;
  originalEventId: string;
  originalEventType: string;
  confirmation: keyof typeof EBilledEventConfirmation;
  content: TAnyObject;
  createdAt: string;
};

export type TDebtTransaction = {
  id: number;
  eventId: number;
  tenantId: number;
  reason: string;
  reasonCode: string;
  balanceId: number;
  amount: number;
  currency: TCurrency;
  createdAt: string;
  details: TAnyObject;
};

export type TTransaction = {
  id: number;
  eventId: number;
  tenantId: number;
  reason: string;
  reasonCode: string;
  balanceId: number;
  openingBalance: number;
  amount: number;
  currency: TCurrency;
  createdAt: string;
  state: TBilledEventState;
};

export type TBilledEventData = {
  billedEvent: TBilledEvent | null;
  debtTransaction: TDebtTransaction | null;
  transaction: TTransaction | null;
};

export type TStornoFormData = {
  correctionType: EPaymentCorrectionType;
  originalEventId: string | null;
  comment?: string;
  sum?: number | null;
};

export enum EPayKeeperPaymentStatus {
  NEW = 'NEW',
  PAYMENT_INITIATED = 'PAYMENT_INITIATED',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  PAID = 'PAID',
  STUCK = 'STUCK',
  CANCELLED = 'CANCELLED',
  REFUND_INITIATED = 'REFUND_INITIATED',
  REFUND_WITHDRAWN = 'REFUND_WITHDRAWN',
  REFUND_WITHDRAW_FAILED = 'REFUND_WITHDRAW_FAILED',
  REFUND_FAILED = 'REFUND_FAILED',
  REFUNDING = 'REFUNDING',
  REFUNDED = 'REFUNDED',
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
}

export type TPayKeeperPayment = {
  id: string;
  paymentId?: number;
  tenantId: number;
  userId: number;
  sum: number;
  refundedSum?: number;
  status: EPayKeeperPaymentStatus;
  createdAt: string;
  updatedAt?: string;
};

export type TPayKeeperPaymentPayload = {
  date: string;
  userId: number;
};
